import React from 'react'
import "./notify.scss"
export default function Notify() {
    return (
        <div className="notify">
            eroor in fire base
        </div>
    )
}
export const notify = (message)=>{
    const notifyElement = document.querySelector(".notify");
    notifyElement.innerHTML=message
    notifyElement.classList.add("show");
    setTimeout(()=>{
        notifyElement.classList.remove("show");
        notifyElement.innerHTML=""
    },3000)
}

